import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserDto } from '../../model/user/user-dto';
import { SessionInfo } from '../../model/session.info';

@Injectable({
  providedIn: 'root'
})
export class SessionService extends BaseService {

  resourceUrl = 'session';

  //Sessionda Tuttuğumuz User Bilgilerini Çeken Servis
  getInitUser(trackingId: string): Observable<UserDto> {
    return this.get(`init/user/${trackingId}`);
  }
  //Firmanın logosunu çeken servis şimdilik kullanılmıyor ileride kullanılabilir.
  getBrandIcon(trackingId: string): Observable<string> {
    return this.get(`brandIcon/${trackingId}`);
  }
  //Timeout süresi ve firma logosunu aldığımız servis.
  getSessionInfo(trackingId: string): Observable<SessionInfo> {
    return this.get(`init/info/${trackingId}`);
  }

  getHttpParams(): HttpParams {
    return undefined;
  }

  getPath(): string {
    return this.resourceUrl;
  }
}
